import gql from "graphql-tag";

import {GraphQLResponse} from "@/lib/types/common.ts";
import {MonitoringServer, PrivateLocation} from "@/lib/types/monitoring.ts";

export const GQL_MONITORING_SERVERS_LIST = gql`
  query MonitoringServers(
    $limit: Int!
    $offset: Int!
    $sort: String!
    $search: String
    $filters: MonitoringServersFilters
  ) {
    monitoringServers(limit: $limit, offset: $offset, sort: $sort, search: $search, filters: $filters) {
      total
      items {
        id
        group_id
        name
        location
        country
        is_nagios
        address_ipv4
        address_ipv6
        address_ipv4_list
        address_ipv6_list
        monitoring_level
      }
    }
  }
`;

export interface MonitoringServerItems {
  items: MonitoringServer[];
  total: number;
}

export interface MonitoringServersListResult {
  monitoringServers: MonitoringServerItems;
}

export const GQL_MONITORING_SERVER_FILTER_DATA_LOCATIONS = gql`
  query PublicProbeServerLocations {
    values: monitoringServerLocations {
      total
      items {
        key: location
        display: location
      }
    }
  }
`;

export const GQL_PRIVATE_LOCATIONS_LIST_QUERY = gql`
  query PrivateLocations($limit: Int!, $offset: Int!, $sort: String!, $search: String) {
    privateLocations(limit: $limit, offset: $offset, sort: $sort, search: $search) {
      total
      items {
        id
        name
        location
        version
        created_at
        status {
          status
          details {
            check_alert_queue {
              status
              description
            }
            check_load {
              status
              description
            }
            check_mem {
              status
              description
            }
            check_nag {
              status
              description
            }
            check_perfdata_log {
              status
              description
            }
            check_reconfig_log {
              status
              description
            }
            check_send_alert_errors {
              status
              description
            }
            check_stalled_check_detection_log {
              status
              description
            }
            check_total_procs {
              status
              description
            }
            check_txn_manager {
              status
              description
            }
            last_check_times {
              status
              description
            }
          }
          sent_at
          description
          received_at
          image_major_version
          image_minor_version
        }
        api_token
        num_services
      }
    }
  }
`;

export interface PrivateLocationsItems {
  items: PrivateLocation[];
  total: number;
}

export interface PrivateLocationsListResult {
  privateLocations: PrivateLocationsItems;
}

export type UpdatePrivateLocationResult = GraphQLResponse<PrivateLocation>;

export const GQL_UPDATE_PRIVATE_LOCATION = gql`
  mutation UpdatePrivateLocation($data: UpdatePrivateLocationInput!) {
    response: updatePrivateLocation(data: $data) {
      ... on UpdatePrivateLocationSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export type ProvisionPrivateLocationResult = GraphQLResponse<PrivateLocation>;

export const GQL_PROVISION_PRIVATE_LOCATION = gql`
  mutation ProvisionPrivateLocation {
    response: ProvisionPrivateLocation {
      ... on ProvisionPrivateLocationSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_DELETE_PRIVATE_LOCATION = gql`
  mutation DeletePrivateLocation($server_id: ID!) {
    response: DeletePrivateLocation(server_id: $server_id) {
      ... on DeletePrivateLocationSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_PRIVATE_LOCATIONS_SERVICE_QUERY = gql`
  query PrivateLocationService($server_id: ID!, $limit: Int!, $offset: Int!, $sort: String) {
    privateLocationServices(server_id: $server_id, limit: $limit, offset: $offset, sort: $sort) {
      total
      items {
        id
        name
        type
      }
    }
  }
`;
